module.exports = __webpack_public_path__ + "img/contenedor14.ebe6e0a6.png";